import { FC } from "react";
import { ExternalLinkIcon } from "@snapchat/snap-design-system-icons";
import { headerStyle } from "./PageHeader.styles";

interface PageHeaderProps {
    text: string;
    docHref?: string;
}

export const PageHeader: FC<PageHeaderProps> = ({ text, docHref }) => {
    return (
        <header>
            <h1 css={headerStyle}>
                {text}
                {docHref ? (
                    <a href={docHref} target="_blank" style={{ float: "right" }}>
                        <ExternalLinkIcon size={24} />
                    </a>
                ) : null}
            </h1>
        </header>
    );
};
